import { render } from "./ConstructorPanel.vue?vue&type=template&id=8f8f5aa4&scoped=true&ts=true"
import script from "./ConstructorPanel.vue?vue&type=script&lang=ts"
export * from "./ConstructorPanel.vue?vue&type=script&lang=ts"

import "./ConstructorPanel.vue?vue&type=style&index=0&id=8f8f5aa4&lang=scss&scoped=true"

import exportComponent from "/srv/users/dyo-frontend/apps/dyo-frontend/public_html/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-8f8f5aa4"]])

export default __exports__